import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "bridgetown-lit-renderer"
import "./nav-overlay.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
